module.exports = __webpack_public_path__ + "assets/img/logo-splash.e9d94d38.png";